import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

const Protect = () => {
  return (
    <div className="protect_solution p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <StaticImage
              src="../../../images/solution/music/protect.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={643}
              height={667}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1"
          >
            <h2>How We Will Protect Your Streaming Content With DRM?</h2>
            <p>
              When you want to get a platform built for streaming video or music
              files, you are always concerned about ensuring the security of
              your content at all costs.
            </p>
            <p>
              At Tekrevol, we offer the best content protection through Digital
              Rights Management or DRM. Your content will always be cordoned off
              from unauthorized use as our specialist streaming app development
              team bounds your content to only be accessed via a specified
              server.
            </p>
            <p>
              We offer specific encoding, packaging, playback and a list of
              licensed servers specifically custom developed for you to offer
              the best in protected streaming app development technology out
              there.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Connect!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Protect;
